﻿(function () {
    "use strict";

    window.ToyotaForms = {
        API: {
            Address:{
                AutoComplete: {
                    DealerAddressBySuburbPostcode: "/main/api/v1/toyotaforms/address/dealeraddress/{0}?maxresults={1}",
                    CustomerAddressByAddress: "/main/api/v1/toyotaforms/address/autocomplete/{0}"
                },
                ById: "/main/api/v1/toyotaforms/address/addressbyid/{0}"
            },
            Info: {
                Dealers: "/main/api/v1/toyotaforms/info/dealers/{0}/{1}?maxresults={2}&servicetype={3}"
            },
            Validation: {
                Phone: "/main/api/v1/toyotaforms/validate/phone?number={0}",
                Email: "/main/api/v1/toyotaforms/validate/email?email={0}",
                Postcode: "/main/api/v1/toyotaforms/validate/postcode/{0}"
            },
            FormSubmission: {
                BookATestDrive: "/main/api/v1/toyotaforms/bookatestdrive/submit",
                ContactADealer: "/main/api/v1/toyotaforms/contactadealer/submit",
                RegisterMyInterest: "/main/api/v1/toyotaforms/registermyinterest/submit",
                ContactUs: "/main/api/v1/toyotaforms/contactus/submit",
                ContactUsUplift: "/main/api/v1/toyotaforms/contactusuplift/submit",
                KeepMeInformed: "/main/api/v1/toyotaforms/keepmeinformed/submit",
                Takata: "/main/api/v1/toyotaforms/takata/submit",
                ChangeOwnership: "/main/api/v1/toyotaforms/changeownership/submit"
            }
        },
        RegularExpressions: {
            EmailPattern: /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)$/i,
            SuburbPostcodePattern: /^([a-zA-Z]+(['-\s][a-zA-Z]+)*|[0-9]+)$/
        },
    };
})();
